module.exports = __webpack_public_path__ + "static/media/DownloadReportIcon.0ece13d3.png";